import { useCallback, useEffect, useState } from "react";
import { getConfirmedOrders } from "../../Services/orderService";
import { Form } from "react-bootstrap";
import { MdDashboard } from "react-icons/md";
import { GrDeliver } from "react-icons/gr";
import { GiReturnArrow } from "react-icons/gi";
import { CiAlarmOn } from "react-icons/ci";

const Dashboard = () => {

    const [orders, setOrders] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [selectedOrders, setSelectedOrders] = useState([]);
    const [bulkStatus, setBulkStatus] = useState("pending");
    const [loading, setLoading] = useState(false);

    const [filters, setFilters] = useState({
        status: "all",
        from: "",
        to: "",
        trackingId: ""
    });

    const itemsPerPage = 50;


    console.log("all orders on dashboard", orders)

    // ✅ DATE FORMAT FIX
    const formatDateForAPI = (date, isEnd = false) => {
        if (!date) return undefined;

        const d = new Date(date);

        if (isEnd) {
            d.setHours(23, 59, 59, 999); // end of day fix
        } else {
            d.setHours(0, 0, 0, 0);
        }

        return d.toISOString();
    };

    const fetchOrders = useCallback(async () => {
        try {
            setLoading(true);

            const params = {
                page,
                status: filters.status !== "all" ? filters.status : undefined,
                from: formatDateForAPI(filters.from),
                to: formatDateForAPI(filters.to, true),
                trackingId: filters.trackingId || undefined
            };

            const res = await getConfirmedOrders(params);

            if (res?.status === "success") {
                setOrders(res.data || []);
                setTotalPages(res.totalPages || 1);
            } else {
                setOrders([]);
            }

        } catch (err) {
            console.error("Order fetch error:", err);
            setOrders([]);
        } finally {
            setLoading(false);
        }
    }, [page, filters]);

    // ✅ Proper debounce
    useEffect(() => {
        const delay = setTimeout(() => {
            fetchOrders();
        }, 400);

        return () => clearTimeout(delay);
    }, [fetchOrders]);


    const statusCounts = orders.reduce(
        (acc, order) => {
            if (order.status === "pending") acc.pending++;
            else if (order.status === "delivered") acc.delivered++;
            else if (order.status === "returned") acc.returned++;
            return acc;
        },
        { pending: 0, delivered: 0, returned: 0 }
    );

    // use like this
    const pendingCount = statusCounts.pending;
    const deliveredCount = statusCounts.delivered;
    const returnedCount = statusCounts.returned;

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setPage(1);
        setFilters(prev => ({ ...prev, [name]: value }));
    };

    return (
        <>

            <div className="row">
                <div className="col">
                    <h4 className="fw-semibold">Dashboard</h4>
                </div>
                <div className="col-auto">
                    <div className="row g-2 mb-3 align-items-end justify-content-end">
                        <div className="col-auto">
                            <Form.Label>From</Form.Label>
                            <Form.Control
                                type="date"
                                name="from"
                                value={filters.from}
                                onChange={handleFilterChange}
                            />
                        </div>

                        <div className="col-auto">
                            <Form.Label>To</Form.Label>
                            <Form.Control
                                type="date"
                                name="to"
                                value={filters.to}
                                onChange={handleFilterChange}
                            />
                        </div>


                    </div>
                </div>

            </div>
            <div className="row justify-content-around">

                <div className="col-lg-3">
                    <div className="py-4 px-3 rounded-3 shadow d-flex justify-content-center aligh-items-center flex-column">
                        <div className="row">
                            <div className="col">
                                <h4 className="mb-0 text-primary fw-bold">Total</h4>
                            </div>
                            <div className="col-auto">
                                <MdDashboard className="text-primary" size={28} />

                            </div>
                        </div>
                        <div>
                            <h1 className="pt-3 text-primary fw-bold text-center mb-0">
                                {orders?.length}
                            </h1>
                        </div>

                    </div>
                </div>

                <div className="col-lg-3">
                    <div className="py-4 px-3 rounded-3 shadow d-flex justify-content-center aligh-items-center flex-column">
                        <div className="row">
                            <div className="col">
                                <h4 className="mb-0 text-success fw-bold">Delivered</h4>
                            </div>
                            <div className="col-auto">
                                <GrDeliver size={28} className="text-success" />

                            </div>
                        </div>
                        <div>
                            <h1 className="pt-3 text-success fw-bold text-center mb-0">
                                {deliveredCount}
                            </h1>
                        </div>

                    </div>
                </div>



                <div className="col-lg-3">
                    <div className="py-4 px-3 rounded-3 shadow d-flex justify-content-center aligh-items-center flex-column">
                        <div className="row">
                            <div className="col">
                                <h4 className="mb-0  text-danger fw-bold">Returned</h4>
                            </div>
                            <div className="col-auto">
                                <GiReturnArrow size={28} className="text-danger" />

                            </div>
                        </div>
                        <div>
                            <h1 className="text-danger pt-3 fw-bold text-center mb-0">
                                {returnedCount}
                            </h1>
                        </div>

                    </div>
                </div>



                <div className="col-lg-3">
                    <div className="py-4 px-3 rounded-3 shadow d-flex justify-content-center aligh-items-center flex-column">
                        <div className="row">
                            <div className="col">
                                <h4 className="mb-0 text-warning fw-bold">Pending</h4>
                            </div>
                            <div className="col-auto">
                                <CiAlarmOn className="text-warning" size={28} />

                            </div>
                        </div>
                        <div>
                            <h1 className="pt-3 text-warning fw-bold text-center mb-0">
                                {pendingCount}
                            </h1>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )


}


export default Dashboard;